
import { defineComponent } from "vue";

export default defineComponent({
	name: 'RecursiveTaxonomyGroup',
	props: {
		tax: {
			required: true,
			type: Object
		},
		slug: {
			required: true,
			type: String
		},
		groupClass: {
			required: false,
			type: String
		},
	},
	emits: ['updateTaxonomy'],
	expose: ['reset'],
	data() {
		return {
			checkboxes: [] as string[]
		}
	},
	methods: {
		switchId(append: number) {
			return 'vueEventsPluginSwitch' + append
		},
		updateTaxonomy(slug: string, termId: number) {
			this.$emit('updateTaxonomy', slug, termId)
		},
		reset() {
			this.checkboxes = []
			if (this.$refs.recursiveTaxonomyGroup) {
				(this.$refs.recursiveTaxonomyGroup as Array<object>).forEach((group:object) => {
					(group as typeof this).reset();
				});
			}
		},
	},
	mounted() {
		Object.keys(this.tax.items).forEach(index => {
			if (this.$route.query[this.slug + '[]']) {
				if (this.$route.query[this.slug + '[]']?.includes(index) || this.checkboxes.includes(index)) {
					this.checkboxes.push(index);
				}
			}
		})
	}
})
